
import Vue from 'vue'
import { Component, Prop } from 'vue-property-decorator'
import { palette } from '@/utils/palette'
import { PredefinedNoticeTypes } from '@/utils/notices'
import TextBadge from '@/components/TextBadge.vue'

@Component<NoticeTypeBadge>({
    components: { TextBadge },
})
export default class NoticeTypeBadge extends Vue {
    @Prop({ type: String, required: false }) private noticeType!: string

    get noticeTypeObj() {
        const noticeTypeObj = PredefinedNoticeTypes.find(
            (type) => type.name === this.noticeType
        )
        if (noticeTypeObj) {
            return noticeTypeObj
        }
        return {
            name: 'Unknown notice type',
            color: palette.black,
            backgroundColor: palette.white,
        }
    }
}
